export const GOLD_RATE_API_URL = "/api/gold-rate.php";
 
export const FALLBACK_GOLD_RATE_PER_GRAM = 16579;
 
export const formatGoldRate = (rate) =>
  `₹${Number(rate).toLocaleString("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`;
 
// Keeps existing components working.
export const GOLD_RATE_DISPLAY = formatGoldRate(
  FALLBACK_GOLD_RATE_PER_GRAM
);